import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "icon", "preview", "clearBtn"]

    preview() {
        const file = this.inputTarget.files[0]
        if (file) {
            const reader = new FileReader()
            reader.onload = (e) => {
                // Show preview, hide icon
                this.previewTarget.src = e.target.result
                this.previewTarget.classList.remove("hidden")
                if (this.hasIconTarget) this.iconTarget.classList.add("hidden")
                if (this.hasClearBtnTarget) this.clearBtnTarget.classList.remove("hidden")
            }
            reader.readAsDataURL(file)
        }
    }

    clear(e) {
        if (e) {
            e.preventDefault()
        }
        this.inputTarget.value = ""
        this.previewTarget.src = ""
        this.previewTarget.classList.add("hidden")
        if (this.hasIconTarget) this.iconTarget.classList.remove("hidden")
        if (this.hasClearBtnTarget) this.clearBtnTarget.classList.add("hidden")
    }
}
